import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import CommonSection from "../shared/CommonSection";
import "./../styles/blogpage.css";
import { useNavigate, useLocation } from "react-router-dom"; // Import useNavigate
import AchievementsSection from "../shared/AchievementsSection";
import { Helmet } from "react-helmet";
import Newsletter from "../shared/Newsletter";

//Imges of the Blogs
import blog3 from "./../assets/images/gt-mobile.png";
import blog4 from "./../assets/images/delhi.jpg";
import blog5 from "./../assets/images/amer.png";
import blog6 from "./../assets/images/jaisalmer-blog.png";
import blog7 from "./../assets/images/golden-tour6.jpg";
import blog8 from "./../assets/images/city-palace.jpg";
import blog9 from "./../assets/images/what can you do in jaipur for a full day.png";
import Subtitle from "../shared/Subtitle";

const Blogs = () => {
  const location = useLocation();
  const storedCategory = location.state?.selectedCategory || "";
  const [selectedCategory] = useState(storedCategory);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const tourData = [
    {
      name: "What can you do in Jaipur for a full day The Rustic Paths perspective",
      title: "What can you do in Jaipur for a full day?",
      image: blog9,
      date: "October 16, 2024",
      previewText: "Discover Jaipur in one day with The Rustic Paths. Visit Amber Fort, City Palace, Hawa Mahal, and more on this unforgettable journey.",
    },
    {
      name: "How to Plan a Perfect One-Day Trip to Jaipur: A Complete Guide",
      title: "A Perfect One-Day Jaipur Sightseeing Tour",
      image: blog8,
      date: "October 14, 2024",
      previewText: "Explore Jaipur in one day with this sightseeing tour of the Pink City, visiting top attractions like Amber Fort, Hawa Mahal, City Palace, Jantar Mantar, and Nahargarh Fort.",
    },
    {
      name: "Epic Adventure The Golden Triangle Tour with Ranthambore",
      title: "Golden Triangle Tour with Ranthambore",
      image: blog7,
      date: "September 27, 2024",
      previewText: "Discover the best time to visit Jaisalmer, the Golden City of India, nestled in the Thar Desert. Opt for a The Rustic Paths for a seamless journey and personalized experience.",
    },
    {
      name: "Golden City Best Time to Visit Jaisalmer",
      title: "Best Time to Visit Jaisalmer",
      image: blog6,
      date: "September 25, 2024",
      previewText: "Discover the best time to visit Jaisalmer, the Golden City of India, nestled in the Thar Desert. Opt for a The Rustic Paths for a seamless journey and personalized experience.",
    },
    {
      name: "Exploring Unforgettable Experience Rajasthan Tour",
      title: "Rajasthan Tour",
      image: blog5,
      date: "September 20, 2024",
      previewText: "Discover the essence of India's 'Land of Kings' with our comprehensive guide. Plan your unforgettable Rajasthan tour today!",
    },
    {
      name: "Essential Things to Carry for Your Delhi Sightseeing Tour",
      title: "Delhi Sightseeing Tour",
      image: blog4,
      date: "September 18, 2024",
      previewText: "Discover the essentials you need to pack for a memorable Delhi sightseeing experience.",
    },
    {
      name: "Uncover the Majestic Beauty of India with Golden Triangle Tour Packages",
      title: "Golden Triangle Tour Packages: Delhi, Agra, Jaipur",
      image: blog3,
      date: "September 13, 2024",
      previewText: "Embark on a captivating journey through Delhi, Agra, and Jaipur with our Golden Triangle Tour Packages. ",
    },
    
  ];
  const navigate = useNavigate();

  const filteredtours = tourData.filter(
    (tour) => tour.category === selectedCategory || selectedCategory === ""
  );

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedCategory]);

  const indexOfLasttour = currentPage * itemsPerPage;
  const indexOfFirsttour = indexOfLasttour - itemsPerPage;
  const currenttours = filteredtours.slice(indexOfFirsttour, indexOfLasttour);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);

    window.scrollTo(0, 0);
  };

  // Function to navigate to the tour details page
  const navigateToTourDetails = (tourCategory, tourName) => {
    // const categorySlug = tourCategory.split(" ").join("-").toLowerCase();
    const tourNameSlug = tourName.split(" ").join("-").toLowerCase();
    navigate(`/blogs/${tourNameSlug}`);
  };

  return (
    <>
      <Helmet>
        <meta charSet="UTF-8" />
        <title>Our Blogs - The Rustic Paths</title>
        <meta name="Discover the best destinations, insider tips, and unique experiences with The Rustic Paths. Immerse yourself in the essence of this diverse country through our insightful narratives and embark on unforgettable journeys. Read our short travel blogs for a quick dose of inspiration and plan your next adventure hassle-free. Let us be your guide to the heart of India's wonders.!" />
        <meta
          name="keywords"
          content="our blogs, read our blogs, our blog page, travel blogs india, best travel blogs, unique travel blogs, short travel blog, The Rustic Paths"
        />
        {/* Add other meta tags as needed */}
        <script type="application/ld+json">
          {`{"@context": "https://schema.org",
  "@type": "BlogPosting",
  "headline": "Our Blogs - The Rustic Paths",
  "description": "Explore our diverse tour packages.",
  "keywords": "our blogs, read our blogs, our blog page, travel blogs india, best travel blogs, unique travel blogs, short travel blog"}`}
        </script>
        <script type="application/ld+json">
          {`
  {
    "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [{
    "@type": "ListItem",
    "position": 1,
    "name": "Home",
    "item": "https://therusticpaths.com"
  },{
    "@type": "ListItem",
    "position": 2,
    "name": "Blog",
    "item": "https://therusticpaths.com/blogs"
  }]
  }
  `}
        </script>
      </Helmet>
      <CommonSection title={"Our Blogs"} />
      <section className="tour-rental-section py-12">
        <Container>
          <Row>
            <div className="container mx-auto px-4 ">
              <h2 className="text-3xl font-semibold text-gray-800 mb-8 ">
                Read Our Popular Blogs
              </h2>

              <Row>
                {currenttours.map((tour, index) => (
                  <Col key={index} sm="12" md="6" lg="4" className="mb-4">
                    <div
                      className="tour__option bg-white p-6 rounded-lg shadow-lg flex relative"
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <div className="w-1/2">
                        <img
                          src={tour.image}
                          alt={tour.title}
                          className="w-full h-auto"
                        />
                      </div>
                      <div className="text w-1/2">
                        <h3 className="text-xl font-semibold text-gray-800 mb-4 text-center border-b pb-2">
                          {tour.title}
                        </h3>
                        {hoveredIndex === index && (
                          <p className="preview-text">{tour.previewText}</p>
                        )}
                        <p className="text-sm text-gray-600 mb-2 text-center">{tour.date}</p>
                        <div className="text-center ">
                          <button
                            onClick={() =>
                              navigateToTourDetails(tour.category, tour.name)
                            }
                            className="btn primary__btn bg-blue-500 text-white px-4 py-3 rounded-full hover.bg-blue-600 mb-4"
                          >
                            Read Our Blog
                          </button>
                        </div>
                      </div>
                      <div className="blur-border"></div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
            <div className="pagination">
              {filteredtours.length > itemsPerPage &&
                Array(Math.ceil(filteredtours.length / itemsPerPage))
                  .fill()
                  .map((_, index) => (
                    <button
                      key={index}
                      onClick={() => handlePageChange(index + 1)}
                      className={`page-button ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                    >
                      {index + 1}
                    </button>
                  ))}
            </div>
            <Col lg="12">
              {/* Add the ElfSight testimonial widget div */}
              <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
            </Col>
          </Row>
        </Container>
      </section>
      {/*--------------------------- Our Achievements Section Start--------------------------*/}
      <section>
        <Container>
          <Row>
            <Col lg="12">
              {/* <div style={{ backgroundColor: "#ffffff" }}>
                <h2 align="center" className="services__subtitle">
                  Few of our achievements
                </h2>
              </div> */}
              <Subtitle subtitle={"Few of our achievements"}/>
            </Col>
            <Col lg="12">
              <AchievementsSection />
            </Col>
          </Row>
        </Container>
      </section>

      {/*--------------------------- Our Achievements Section End--------------------------*/}
      <Newsletter />
    </>
  );
};

export default Blogs;
